import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, MapPin } from 'lucide-react';
import { navItems } from '../mock';

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-[#FFFBF5]/85 backdrop-blur-md border-b border-stone-200/70">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <span className="w-9 h-9 rounded-xl bg-[#F97316] flex items-center justify-center shadow-sm">
            <MapPin size={18} className="text-white" strokeWidth={2.5} />
          </span>
          <span className="text-[22px] font-extrabold tracking-tight text-stone-900" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            Ambanji
          </span>
          <span data-testid="beta-badge" className="text-[10px] font-bold text-[#4F46E5] bg-[#4F46E5]/10 border border-[#4F46E5]/30 rounded-full px-2 py-0.5 tracking-wide">
            BETA
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="relative text-[14px] font-medium text-stone-700 hover:text-stone-900 transition-colors"
            >
              {item.label}
              {item.badge && (
                <span className="absolute -top-2.5 -right-6 text-[9px] font-bold text-white bg-[#F97316] rounded px-1.5 py-0.5">
                  {item.badge}
                </span>
              )}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/login" data-testid="header-portal-login-link" className="px-5 py-2.5 text-[15px] font-bold text-stone-800 border-2 border-stone-300 rounded-lg hover:border-stone-900 hover:text-stone-900 transition">
            Log in
          </Link>
          <a
            href="#audit"
            className="px-5 py-2.5 text-[13px] font-bold text-white bg-[#4F46E5] rounded-lg hover:bg-[#4338CA] hover:shadow-lg hover:-translate-y-0.5 transition"
          >
            Get free heatmap
          </a>
        </div>

        <button className="lg:hidden text-stone-800" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FFFBF5] border-t border-stone-200 px-6 py-4 space-y-3">
          {navItems.map((item) => (
            <a key={item.label} href={item.href} className="block text-[15px] font-medium text-stone-800">
              {item.label}
            </a>
          ))}
          <div className="flex gap-3 pt-3">
            <Link to="/login" data-testid="header-portal-login-link-mobile" className="flex-1 text-center py-3 text-[15px] font-bold border-2 border-stone-300 rounded-lg">Log in</Link>
            <a href="#audit" className="flex-1 text-center py-2.5 text-[13px] font-bold text-white bg-[#4F46E5] rounded-lg">Free heatmap</a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
